export default __webpack_public_path__ + "static/Krzysztof_websize-e6183bd4c4bbb9ef064f9957f81b07be.jpg";